/* unplugin-vue-components disabled */import { render } from "./routedata.vue?vue&type=template&id=0c6bb222&scoped=true"
import script from "./routedata.vue?vue&type=script&lang=js"
export * from "./routedata.vue?vue&type=script&lang=js"

import "./routedata.vue?vue&type=style&index=0&id=0c6bb222&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6bb222"]])

export default __exports__